import { GameState, GameMode } from '../types/GameTypes';
import { GAME_CONSTANTS } from '../utils/Constants';

export class GameStateManager {
  private state: GameState;

  constructor(mode: GameMode = 'sp', playerCount: number = 1) {
    this.state = {
      mode,
      waveNumber: 0,
      isSurvivalMode: false,
      hp: GAME_CONSTANTS.PLAYER_BASE_HP * playerCount,
      maxHp: GAME_CONSTANTS.PLAYER_BASE_HP * playerCount,
      economy: {
        gold: 150, // Starting gold to allow initial building
        gpm: GAME_CONSTANTS.GPM_BASE,
        killGoldTier: GAME_CONSTANTS.KILL_GOLD_BASE,
        goldFrozen: false,
      },
      grid: [],
      towers: [],
      enemies: [],
      walls: [],
      totems: [],
      spawns: [],
      goals: [],
    };
  }

  getState(): GameState {
    return this.state;
  }

  getHP(): number {
    return this.state.hp;
  }

  getMaxHP(): number {
    return this.state.maxHp;
  }

  takeDamage(amount: number): void {
    this.state.hp = Math.max(0, this.state.hp - amount);
  }

  isDead(): boolean {
    return this.state.hp <= 0;
  }

  getWaveNumber(): number {
    return this.state.waveNumber;
  }

  setWaveNumber(wave: number): void {
    this.state.waveNumber = wave;
  }

  enterSurvivalMode(): void {
    this.state.isSurvivalMode = true;
  }

  isSurvivalMode(): boolean {
    return this.state.isSurvivalMode;
  }

  getEconomy() {
    return this.state.economy;
  }

  setEconomy(economy: typeof this.state.economy): void {
    this.state.economy = economy;
  }
}

